import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {TariffFormStore} from './../Storage/tariffStorage';
import {SwsSummary} from "../Pages/swsSummary";
import {getLocallangText} from '../utils';

const swsSummaryEls = document.getElementById('swsSummary');

interface TariffData {
    id: number;
}

@customElement('sws-modal-delete-tariff')
export class swsModalDeleteTariff extends LitElement {

    @property({type: Object})
    tariffData: TariffData = {id: 0};

    @property({type: Number})
    productType?: number;

    @property({type: String})
    productName: string = '';

    @property({ type: Object})
    deliveryData = {};

    @property({type: String})
    selectedTabUid = '';

    @property({type: Number})
    index = 0;

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener('prepare-delete-tariff-modal', (e: Event) => {
            const data = (e as CustomEvent).detail;

            this.productType = data.productType;
            this.productName = data.productName;
            this.selectedTabUid = data.selectedTabUid;
            this.index = data.index || 0;

            // Tief kopieren, um Reaktivität zu garantieren:
            this.tariffData = structuredClone(data.tariffData);

            this.requestUpdate();
        });
    }


    protected createRenderRoot() {
        return this;
    }

    private _deleteTariff(e: Event) {
        e.preventDefault();

        if( this.selectedTabUid ) {
            const event = new CustomEvent('tariff-deleted', {
                detail: {
                    tariffUid: this.selectedTabUid
                },
                bubbles: true,
                composed: true
            });
            this.dispatchEvent(event);
        } else {
            const allTariffs = TariffFormStore.get('allTariffs') || [];
            TariffFormStore.delete(this.index);

            const updatedTariffs = allTariffs.filter((t: { id: number }) => t.id !== this.tariffData.id);
            TariffFormStore.set('allTariffs', updatedTariffs);

            (swsSummaryEls as SwsSummary).updateElement();

            if(!TariffFormStore.get('allTariffs')?.length) {
            }
        }
    }

    protected render() {
        if (!this.tariffData) {
            return html`${TYPO3?.lang?.[`modal.deleteTariff.noProduct`]}`;
        }

        return html`
            <p class="m-0">${getLocallangText("modal.deleteTariff.infobox", [this.productName])}</p>
            <div class="w-100 d-grid d-flex flex-column">
                <button
                    data-bs-dismiss="modal"
                    class="btn btn-primary w-100 mt-4 mb-2 text-white"
                    @click=${(e: Event) => this._deleteTariff(e)}>
                    ${TYPO3?.lang?.[`modal.deleteTariff.acceptDelete`]}
                </button>
                <a href="#" class="btn btn-link btn-back text-black" data-bs-toggle="modal" data-bs-target="#modal-change-tariff" aria-label="Close">${TYPO3?.lang?.[`modal.deleteTariff.cancelDelete`]}</a>
            </div>

        `;
    }
}
